<template>
  <div>
    <!-- <Header /> -->

    <div class="flex">
      <SideBar />
      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-3 h-full">
          <div class="flex justify-end w-full px-10 py-5">
            <div class="relative">
              <form @submit.prevent="searchValue">
                <input
                  type="text"
                  placeholder="Search"
                  id="search"
                  v-model="search_title"
                  @input="searchValue"
                  class="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-300 hover:bg-gray-100 transition-all duration-200"
                />
                <button type="submit" class="">
                  <div class="absolute right-3 top-2.5 h-5 w-5 text-gray-400">
                    <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                  </div>
                </button>
              </form>
            </div>
          </div>
          <div
            class="w-full overflow-x-auto rounded-lg border border-gray-200 shadow-sm"
          >
            <table class="min-w-full text-sm">
              <thead class="bg-gray-100">
                <tr>
                  <th
                    class="py-3 px-4 border text-center border-r text-blues whitespace-nowrap"
                  >
                    S NO
                  </th>
                  <th class="py-3 px-4 border text-center border-r text-blues">
                    Name
                  </th>
                  <th class="py-3 px-4 border text-center border-r text-blues">
                    Email
                  </th>

                  <th
                    class="py-3 px-4 border text-center border-r text-blues whitespace-nowrap"
                  >
                    Start Date
                  </th>

                  <th
                    class="py-3 px-4 border text-center border-r text-blues whitespace-nowrap"
                  >
                    End Date
                  </th>

                  <th class="py-3 px-4 border text-center border-r text-blues">
                    Percentage
                  </th>
                  <th class="py-3 px-4 border text-center border-r text-blues">
                    Perview
                  </th>
                </tr>
              </thead>

              <tbody
                v-if="this.complete_detail.length > 0"
                class="divide-y divide-gray-100"
              >
                <tr
                  v-for="(el, index) in this.complete_detail"
                  :key="el"
                  class="hover:bg-gray-50 transition"
                >
                  <td
                    class="py-3 px-4 border-b text-center border-r text-blue-600"
                  >
                    {{ index + 1 }}
                  </td>
                  <td class="py-3 px-4 border-b text-center border-r">
                    <p v-if="el.display_name" class="text-gray-800">
                      {{ el.display_name }}
                    </p>
                    <p v-else class="text-gray-700">NA</p>
                  </td>
                  <td
                    class="py-3 px-4 border-b text-center border-r whitespace-nowrap"
                  >
                    <p v-if="el.email" class="text-gray-700">{{ el.email }}</p>
                    <p v-else class="text-gray-700">NA</p>
                  </td>
                  <td
                    class="py-3 px-4 border-b text-center border-r whitespace-nowrap"
                  >
                    <p v-if="el.start_time" class="text-gray-700">
                      {{ formatDate(el.start_time) }}
                    </p>
                    <p v-else class="text-gray-700">NA</p>
                  </td>
                  <td
                    class="py-3 px-4 border-b text-center border-r whitespace-nowrap"
                  >
                    <p v-if="el.end_time" class="text-gray-700">
                      {{ formatDate(el.end_time) }}
                    </p>
                    <p v-else class="text-gray-700">NA</p>
                  </td>
                  <td class="py-3 px-4 border-b text-center border-r">
                    <p v-if="el.percentage" class="text-gray-700">
                      {{ el.percentage }}
                    </p>
                    <p v-else class="text-gray-700">NA</p>
                  </td>
                  <td class="py-3 px-4 border-b text-center border-r">
                    <router-link
                      :to="{
                        name: 'InstructorCertificatePage',
                        params: { all_course_id: el.course_id },
                      }"
                      target="_blank"
                      class="text-sm sm:text-md text-[#0085DB] font-medium cursor-pointer"
                    >
                      View
                    </router-link>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr class="w-full">
                  <td colspan="8" class="text-center py-6">
                    <div class="w-full flex justify-center items-center">
                      No Data Found
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";

import axios from "axios";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      complete_detail: [],
      search_title: "",
    };
  },
  components: {
    Header,
    SideBar,
  },
  created() {
    this.completecourse();
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  props: ["course_id"],
  methods: {
    async completecourse() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/completed-certificates/?Key=${this.userInfo.token_key}&lesson_track__lesson_id__course_name__id=${this.course_id}`
        )
        .then((response) => {
          this.complete_detail = response.data.data;
        });
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    async searchValue() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/completed-certificates/?Key=${this.userInfo.token_key}&lesson_track__lesson_id__course_name__id=${this.course_id}&search=${this.search_title}`
        )
        .then((response) => {
          this.complete_detail = response.data.data;
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
